export default __webpack_public_path__ + "static/media/office_web-lg@1x.60c2c90e.jpg";